export default {
  name: 'pt-BR',
  global: {
    undo: 'Desfazer',
    redo: 'Refazer',
    confirm: 'Confirmar',
    clear: 'Limpar',
  },
  Popconfirm: {
    positiveText: 'Confirmar',
    negativeText: 'Cancelar',
  },
  Cascader: {
    placeholder: 'Selecione',
    loading: 'Carregando',
    loadingRequiredMessage: (label: string): string => `Carregue todos os sub-itens de ${label} antes de selecionar`,
  },
  Time: {
    dateFormat: 'dd/MM/yyyy',
    dateTimeFormat: 'dd/MM/yyyy HH:mm:ss',
  },
  DatePicker: {
    yearFormat: 'yyyy',
    monthFormat: 'MMM',
    dayFormat: 'eeeeee',
    yearTypeFormat: 'yyyy',
    monthTypeFormat: 'MM/yyyy',
    dateFormat: 'dd/MM/yyyy',
    dateTimeFormat: 'dd/MM/yyyy HH:mm:ss',
    quarterFormat: 'qqq yyyy',
    weekFormat: 'w-yyyy',
    clear: 'Limpar',
    now: 'Agora',
    confirm: 'Fechar',
    selectTime: 'Selecionar hora',
    selectDate: 'Selecionar data',
    datePlaceholder: 'Selecione a data',
    datetimePlaceholder: 'Selecione data e hora',
    monthPlaceholder: 'Selecione o mês',
    yearPlaceholder: 'Selecione o ano',
    quarterPlaceholder: 'Selecione o trimestre',
    weekPlaceholder: 'Selecione a semana',
    startDatePlaceholder: 'Data de início',
    endDatePlaceholder: 'Data de fim',
    startDatetimePlaceholder: 'Data e hora de início',
    endDatetimePlaceholder: 'Data e hora de fim',
    startMonthPlaceholder: 'Mês de início',
    endMonthPlaceholder: 'Mês de fim',
    monthBeforeYear: true,
    firstDayOfWeek: 0 as 0 | 1 | 2 | 3 | 4 | 5 | 6,
    today: 'Hoje',
  },
  DataTable: {
    checkTableAll: 'Selecionar tudo na tabela',
    uncheckTableAll: 'Desmarcar tudo na tabela',
    confirm: 'Confirmar',
    clear: 'Limpar',
  },
  LegacyTransfer: {
    sourceTitle: 'Origem',
    targetTitle: 'Destino',
  },
  Transfer: {
    selectAll: 'Selecionar tudo',
    unselectAll: 'Desmarcar tudo',
    clearAll: 'Limpar tudo',
    total: (num: number): string => `Total ${num} itens`,
    selected: (num: number): string => `Selecionados ${num} itens`,
  },
  Empty: {
    description: 'Nenhum dado',
  },
  Select: {
    placeholder: 'Selecione',
  },
  TimePicker: {
    placeholder: 'Selecionar hora',
    positiveText: 'OK',
    negativeText: 'Cancelar',
    now: 'Agora',
    clear: 'Limpar',
  },
  Pagination: {
    goto: 'Ir para',
    selectionSuffix: 'página',
  },
  DynamicTags: {
    add: 'Adicionar',
  },
  Log: {
    loading: 'Carregando',
  },
  Input: {
    placeholder: 'Digite aqui',
  },
  InputNumber: {
    placeholder: 'Digite aqui',
  },
  DynamicInput: {
    create: 'Criar',
  },
  ThemeEditor: {
    title: 'Editor de tema',
    clearAllVars: 'Limpar todas as variáveis',
    clearSearch: 'Limpar pesquisa',
    filterCompName: 'Filtrar nome do componente',
    filterVarName: 'Filtrar nome da variável',
    import: 'Importar',
    export: 'Exportar',
    restore: 'Restaurar padrão',
  },
  Image: {
    tipPrevious: 'Imagem anterior (←)',
    tipNext: 'Próxima imagem (→)',
    tipCounterclockwise: 'Girar no sentido anti-horário',
    tipClockwise: 'Girar no sentido horário',
    tipZoomOut: 'Diminuir zoom',
    tipZoomIn: 'Aumentar zoom',
    tipDownload: 'Baixar',
    tipClose: 'Fechar (Esc)',
    tipOriginalSize: 'Zoom para tamanho original',
  },
}
